import UAParser from 'ua-parser-js';

import deviceType from 'ua-device-type'


let parser = new UAParser()

class Config {

    constructor(enforcer) {

        this.devicePixelRatio = 1

        // this.devicePixelRatio = 1

        parser.setUA(navigator.userAgent)

        this.browser = parser.getBrowser().name

        this.version = parser.getBrowser().version

        this.os = parser.getOS()

        this.device = deviceType(navigator.userAgent)

        document.body.classList.add(this.device)

    }

    setData(e){

        this.data = e
    }


}

let config = new Config()

export default config;


// WEBPACK FOOTER //
// ./src/scripts/Trail/config.js